import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ProductsComponent } from './pages/products/products.component';
import { ShopRoutingModule } from './shop-routing.module';
import { ProductService } from '../core/services/product.service';
import { ShoppingCartComponent } from './pages/shopping-cart/shopping-cart.component';
import { ShoppingCartSummaryComponent } from './pages/products/shopping-cart-summary/shopping-cart-summary.component';
import { ProductModalComponent } from './pages/products/product-modal/product-modal.component';
import { FilterSortPanelComponent } from './pages/products/filter-sort-panel/filter-sort-panel.component';
import { ProductBusinessAccountComponent } from './pages/products/product-modal/product-business-account/product-business-account.component';
import { ProductBundlesComponent } from './pages/products/product-modal/product-bundles/product-bundles.component';
import { ProductItemComponent } from './pages/products/product-item/product-item.component';
import { SharedModule } from '../shared/shared.module';
import { CartItemsComponent } from './pages/shopping-cart/cart-items/cart-items.component';
import { ProductPreviewComponent } from './pages/products/product-preview/product-preview.component';
import { ItemQuantityComponent } from './pages/shopping-cart/item-quantity/item-quantity.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    ProductsComponent,
    ShoppingCartComponent,
    ShoppingCartSummaryComponent,
    ProductModalComponent,
    FilterSortPanelComponent,
    ProductBusinessAccountComponent,
    ProductBundlesComponent,
    ProductItemComponent,
    CartItemsComponent,
    ProductPreviewComponent,
    ItemQuantityComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ShopRoutingModule,
    SharedModule,
    NgbModule
  ],
  providers: [
    ProductService
  ]
})
export class ShopModule { }
